var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-list-group',[_c('b-row',_vm._l((_vm.complexFilters),function(complexFilter){return _c('div',{key:complexFilter._id,staticClass:"col-12 col-md-6 mb-4"},[_c('b-list-group-item',{class:[
            'complex-filter-list-item',
            ("" + (_vm.selectedComplexFilters.includes(complexFilter._id) ? 'selected' : ''))
          ],on:{"click":function($event){return _vm.selectComplexFilter(complexFilter._id)}}},[_vm._v(_vm._s(complexFilter.name))])],1)}),0)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }